import { render, staticRenderFns } from "./SelectedItemsBlockReset.vue?vue&type=template&id=e22aa2c6"
import script from "./SelectedItemsBlockReset.vue?vue&type=script&lang=js"
export * from "./SelectedItemsBlockReset.vue?vue&type=script&lang=js"
import style0 from "./SelectedItemsBlockReset.vue?vue&type=style&index=0&id=e22aa2c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports